import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'
import { queryParam } from '@/config/queryParam.js'

export const productsTree = (params) => fetchApi.get(constants.ENDPOINT_PRODUCTS_TREE + queryParam(params))
export const categoriesTree = (params) => fetchApi.get(constants.ENDPOINT_CATEGORIES_TREE + queryParam(params))
export const checkProducts = ({ data, field }) => fetchApi.post(constants.ENDPOINT_PRODUCTS_CHECK, { products: data, field })
export const searchProductList = (idList) => fetchApi.post(constants.ENDPOINT_PRODUCTS_SEARCH_LIST, idList)
export const searchProductCategoryList = (idProductCategory) => fetchApi.post(constants.ENDPOINT_CATEGORIA_PRODUTO_SEARCH_LIST, { _id: idProductCategory })
export const productComparisons = (filters) => fetchApi.post(constants.ENDPOINT_PRODUCT_COMPARISONS, filters)
export const categoryComparisons = (filters) => fetchApi.post(constants.ENDPOINT_CATEGORY_COMPARISONS, filters)
